import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from "@mui/material";
import {
  challenges as challengeImages,
  challenges,
} from "../../utils/portalImages";
import { useLocation } from "react-router-dom";
import "../../assets/css/admin-challenges.css";
import { useState, useEffect, useCallback } from "react";
import VimeoPlayer from "../shared/components/VimeoPlayer";
import { Box, Modal, Backdrop, Fade } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchUserChallengesResponse } from "../../api/ChallengesApi";
import AuthenticatedLayout from "../../layouts/AuthenticatedLayout";
import DotPulseBackdrop from "../shared/components/DotPulseBackdrop";

function UserSingleResponse() {
  const location = useLocation();
  const { name, image } = location.state || {};
  const pathParts = location.pathname.split("/");
  const userUuid = pathParts[2];
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showHowModal, setShowHowModal] = useState(false);
  const [selectedFileType, setSelectedFileType] = useState("");
  const [challengeResponse, setChallengeResponse] = useState(null);

  const fetchChallengeUserResponse = useCallback(() => {
    fetchUserChallengesResponse(userUuid)
      .then((response) => {
        const data = response.data;
        setChallengeResponse(data);
      })
      .catch((error) => {
        console.error("Something went wrong, try later", error);
      });
  }, [userUuid]);

  useEffect(() => {
    fetchChallengeUserResponse();
  }, [fetchChallengeUserResponse]);

  if (!challengeResponse) {
    return <DotPulseBackdrop />;
  }

  const handleOpenModal = (file, fileType) => {
    setSelectedFile(file);
    setSelectedFileType(fileType);
    if (fileType === "vimeo") {
      setShowHowModal(true); // opens custom modal
    } else {
      setModalOpen(true); // opens MUI modal
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedFile(null);
    setSelectedFileType("");
  };

  const handleCloseShowHowModal = () => {
    setShowHowModal(false);
    setSelectedFile(null);
    setSelectedFileType("");
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-lg-11 col-12">
          <div className="card">
            <div className="card-body">
              <div className="d-start">
                {image && <img src={image} alt={name} height={50} width={50} />}
                <h1 className="ml-2">{name}</h1>
              </div>
              <div className="pb-4">
                <div className="container-fluid p-0 px-lg-0 px-3">
                  {challengeResponse?.map((challenge, cIndex) => (
                    <div key={challenge.challenge_uuid}>
                      <h3 className="mb-3 px-3 mt-4">
                        {challenge.challenge_title}
                      </h3>
                      {challenge.tasks.map((task, tIndex) => (
                        <Accordion
                          key={`${challenge.challenge_uuid}-${tIndex}`}
                          style={{
                            margin: "0",
                            border: "none",
                            boxShadow: "none",
                            paddingLeft: "0px",
                            backgroundColor: "#f8f9ff",
                            borderTop: "1px solid #e3e4e5",
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            style={{
                              margin: 0,
                              paddingTop: 7,
                              paddingLeft: 5,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="d-center">
                              <label className="checkbox ml-2 pr-2">
                                <input
                                  readOnly
                                  type="checkbox"
                                  className="checkbox__input"
                                  checked={task.is_completed}
                                />
                                <span className="checkbox__inner"></span>
                              </label>
                              <h4
                                style={{
                                  margin: 0,
                                  color: "#32325A",
                                  paddingTop: 4,
                                }}
                              >
                                <span className="text-capitalize w-50 mr-4">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: task.task_title || "N/A",
                                    }}
                                  />
                                </span>
                              </h4>
                            </div>
                            <h5
                              style={{
                                margin: 0,
                                color: "#32325A",
                                paddingBottom: 0,
                                paddingRight: 14,
                                marginLeft: "auto",
                                marginTop: 14,
                              }}
                            >
                              <span className="text-capitalize">
                        <img
                          alt="Gold Medal"
                          style={{ width: "20px", marginRight: "8px" }}
                          src={challenges.trophy}
                        />
                         {`${task.task_point || 1} ${(task.task_point || 1) === 1 ? ' point ' : ' points '}`}
                      </span>
                            </h5>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              backgroundColor: "#f8f9ff",
                              padding: "0px",
                            }}
                          >
                            {task.task_description && (
                              <p className="text-xs text-default ml-3">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: task.task_description,
                                  }}
                                />
                              </p>
                            )}
                            <div className="table-responsive px-3 pb-3 mt-1">
                              {task.response?.text && (
                                <span className="text-md text-default">
                                  <b>Response:</b>{" "}
                                  {task.response?.text || "No Response"}
                                </span>
                              )}

                              <div className="d-flex justify-content-between align-items-center">
                                <div
                                  className="d-flex flex-row"
                                  style={{ gap: "10px" }}
                                >
                                  {task.response?.image && (
                                    <button
                                      onClick={() =>
                                        handleOpenModal(
                                          task.response.image,
                                          "image"
                                        )
                                      }
                                      className="mt-3 mb-1 attachement-btn attachement-btn-text"
                                    >
                                      <img
                                        alt="paper clip"
                                        src={challengeImages.paperClip}
                                        style={{
                                          width: "20px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      View Image
                                    </button>
                                  )}
                                  {task.response?.video && (
                                    <button
                                      onClick={() =>
                                        handleOpenModal(
                                          task.response.video,
                                          "video"
                                        )
                                      }
                                      className="mt-3 attachement-btn attachement-btn-text"
                                    >
                                      <img
                                        alt="paper clip"
                                        src={challengeImages.paperClip}
                                        style={{
                                          width: "20px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      View Video
                                    </button>
                                  )}
                                  {task.response?.audio && (
                                    <button
                                      onClick={() =>
                                        handleOpenModal(
                                          task.response.audio,
                                          "audio"
                                        )
                                      }
                                      className="mt-3 attachement-btn attachement-btn-text"
                                    >
                                      <img
                                        alt="paper clip"
                                        src={challengeImages.paperClip}
                                        style={{
                                          width: "20px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      Listen to Audio
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedFileType !== "vimeo" && (
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{ timeout: 500 }}
        >
          <Fade in={modalOpen}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "auto",
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                outline: "none",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  paddingBottom: "30px",
                }}
              >
                <button
                  onClick={handleCloseModal}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
              </div>

              {/* Preview area */}
              <div>
                {selectedFileType === "image" && (
                  <Tooltip title="Click to view in full screen" placement="top">
                    <img
                      src={selectedFile}
                      alt="Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "400px",
                        width: "auto",
                        height: "auto",
                        display: "block",
                        margin: "0 auto",
                        cursor: "pointer",
                        objectFit: "contain",
                      }}
                      onClick={(e) => {
                        if (e.target.requestFullscreen) {
                          e.target.requestFullscreen();
                        } else if (e.target.webkitRequestFullscreen) {
                          e.target.webkitRequestFullscreen();
                        }
                      }}
                    />
                  </Tooltip>
                )}
                {["video", "admin_tutorial"].includes(selectedFileType) && (
                  <video
                    controls
                    style={{
                      maxWidth: "500px",
                      maxHeight: "400px",
                      width: "100%",
                    }}
                  >
                    <source src={selectedFile} type="video/mp4" />
                  </video>
                )}
                {selectedFileType === "audio" && (
                  <audio controls>
                    <source src={selectedFile} type="audio/mpeg" />
                  </audio>
                )}
              </div>
            </Box>
          </Fade>
        </Modal>
      )}

      <div
        id="video"
        tabIndex="-1"
        role="dialog"
        className={`modal ${showHowModal ? "show" : ""}`}
        style={{
          zIndex: 99999,
          display: showHowModal ? "block" : "none",
        }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{
            maxWidth: "720px",
            margin: "1.75rem auto",
          }}
        >
          <div className="modal-content" style={{ backgroundColor: "white" }}>
            <div className="modal-header pb-0">
              <button
                type="button"
                className="header-close-btn"
                onClick={handleCloseShowHowModal}
              >
                <span aria-hidden="true" className="close-btn-span">
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body hide-scrollbar pt-0">
              <div
                className="wistia_responsive_padding"
                style={{ padding: "56.25% 0 0 0", position: "relative" }}
              >
                <div
                  style={{
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                  }}
                >
                  {selectedFileType === "vimeo" ? (
                    <VimeoPlayer videoId={selectedFile} showPromoVideo={true} />
                  ) : (
                    <video
                      controls
                      src={selectedFile}
                      style={{ width: "100%", height: "100%" }}
                    >
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthenticatedLayout(UserSingleResponse);
